export default "__VITE_ASSET__BV1U9h61__"